<template>
    <div class="row align-items-center">
        <div class="col-md-8 m-auto">
            <div class="text-center mb-4 mt-5 fs-1">
                <h2 class="text__primary">{{$t('message.connexion_formulaire')}}</h2>
            </div>

            <form role="form" class="">
                <base-input class="input-group-alternative mb-3" :placeholder="$i18n.t('message.labelLogin')"
                    addon-left-icon="ni ni-email-83"
                    :valid="$v.model.email.$dirty ? !$v.model.email.$error : null"
                    :error="($v.model.email.$dirty && $v.model.email.$error) ? (!$v.model.email.required ? $t('message.requiredField') : $t('message.emailNotValid')) : null"
                    v-model="$v.model.email.$model">
                </base-input>

                <base-input class="input-group-alternative" :placeholder="$i18n.t('message.password')"
                    type="password" addon-left-icon="ni ni-lock-circle-open" @keyup.enter="submit"
                    :valid="$v.model.password.$dirty ? !$v.model.password.$error : null"
                    :error="($v.model.password.$dirty && $v.model.password.$error) ? (!$v.model.password.required ? $t('message.requiredField') : $t('message.minCharacters', { n: 6 })) : null"
                    v-model="$v.model.password.$model">
                </base-input>
                <div class="d-flex justify-content-end mt--1">
                    <router-link :to="{ name: 'email' }" class="text-light small-text"><small>Mot de passe oublié?</small>
                    </router-link>
                </div>
                
                <base-checkbox class="custom-control-alternative">
                    <span class="text-light">Se souvenir de moi</span>
                </base-checkbox>
                <div class="d-flex justify-content-center" v-if="isLoading">
                    <div class="loading"></div>
                </div>
                <div class="text-center" v-else>
                    <base-button type="primary" class="my-4 w-100 p-text" @click="submit">Connexion</base-button>
                </div>
            </form>
        </div>
        
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { required, email, minLength } from 'vuelidate/lib/validators';
    import AppConfig from '../constants/AppConfig';
    

    export default {
        name: 'login',
        computed: {
            ...mapGetters(["loggedIn"]),
        },
        data() {
            return {
                model: {
                    email: '',
                    password: ''
                },
                isLoading: false
            }
        },

        methods: {
            invalidEmail: function() {
                if (this.$v.model.email.$dirty && this.$v.model.email.$error) {
                    return !this.$v.model.email.required ?
                        this.$i18n.t('message.requiredField') :
                        this.$i18n.t('message.emailNotValid');
                }

                return null;
            },

            submit: function() {
                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        grant_type: 'password',
                        client_id: AppConfig.appClientId,
                        client_secret: AppConfig.appClientSecret,
                        username: this.model.email,
                        password: this.model.password
                    };
                    this.isLoading = true;
                    this.$store.dispatch('loginHandler', { args }).then(() => {
                         setTimeout(() => {
                            this.isLoading = false;
                        }, 5000)
                    }).catch(error => {
                        this.isLoading = false;
                    });
                }
            }
        },

        validations: {
            model: {
                email: {
                    required,
                    // email
                },

                password: {
                    required,
                    minLength: minLength(6)
                }
            }
        },

        watch: {
            $v: {
                handler: function (val) {
                    if(!val.$invalid) {
                        //
                    }
                }
            }
        },
        mounted() {
            if(this.loggedIn){
                this.$router.push({name: localStorage.getItem('dashboardName')});
            }
        }
    }
</script>
<style>
</style>
